const Preview = () => {
  return (
    <>
      <span>Имя отправителя: [Имя отправителя]</span>
      <span>Почта отправителя: [Почта отправителя]</span>

      <div>[Шапка письма]</div>
      <div>[Баннер письма]</div>

      <h1>[Заголовок письма]</h1>
      <p>[Тело письма]</p>
      <span>С уважением,</span>
      <span>[Имя отправителя]</span>

      <div>[Подвал письма]</div>
    </>
  );
};

export default Preview;
